$("a.scrollTo").click(function(event){
	event.preventDefault();
	$('html,body').animate({scrollTop:$(this.hash).offset().top - 51}, 500);
});

